import { z } from 'zod';

import { ProjectStatus, TaskPriority, TaskStatus } from './enums';

// API Validation Schemas
export const projectSchema = z.object({
  title: z.string().min(1, 'Title is required'),
  description: z.string().optional(), // AI-generated summary (max 500 chars)
  details: z.string().optional(), // User-provided context/requirements (max 70,000 chars)
  status: z.enum([
    ProjectStatus.SCOPING,
    ProjectStatus.TASKING,
    ProjectStatus.TODO,
    ProjectStatus.IN_PROGRESS,
    ProjectStatus.DONE,
  ]),
});

export const taskSchema = z.object({
  title: z.string().min(1, 'Title is required'),
  description: z.string().nullable().optional(),
  prompt: z.string().nullable().optional(),
  status: z.enum([TaskStatus.TODO, TaskStatus.IN_PROGRESS, TaskStatus.DONE]),
  priority: z.enum([TaskPriority.LOW, TaskPriority.MEDIUM, TaskPriority.HIGH]),
  projectId: z.string(),
});

export const subtaskSchema = z.object({
  title: z.string().min(1, 'Title is required'),
  description: z.string().optional(),
  completed: z.boolean(),
  taskId: z.string(),
});

// API payload Types
export type CreateProjectPayload = z.infer<typeof projectSchema>;
export type CreateSubtaskPayload = z.infer<typeof subtaskSchema>;
export type CreateTaskPayload = z.infer<typeof taskSchema>;

export type UpdateProjectPayload = Partial<CreateProjectPayload>;
export type UpdateSubtaskPayload = Partial<CreateSubtaskPayload>;
export type UpdateTaskPayload = Partial<CreateTaskPayload>;
